import { Component } from '@angular/core';
import { Pagination } from 'src/app/core/interfaces/pagination.interface';
import { ClaimsPaginationParamsModel } from '../../../data/models/claim-pagination-params.model';
import { ClaimFilterModel } from '../../../data/models/claim-filter.model';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { Failure } from 'src/app/core/utils/failure';
import { GetFinishedSingleUseCase } from '../../../domain/usecases/get-claim-finished-single.usecase';
import { GetFinishedColectiveUseCase } from '../../../domain/usecases/get-claim-finished-colective.usecase';
import { GetFinishedMultiUseCase } from '../../../domain/usecases/get-claim-finished-multi.usecase';
import { FilterServiceService } from '../../../services/filter-service.service';

@Component({
  selector: 'app-claims-archived',
  templateUrl: './claims-archived.component.html',
  styleUrls: ['./claims-archived.component.css'],
  providers: [],
})
export class ClaimsArchivedComponent {
  public pagination: Pagination = {
    totalQuantity: 0,
    numberOfPages: 0,
    itemsPerPage: 5,
    actualPage: 1,
  };

  public skeleton: boolean = false;
  public isPluri: boolean = false;
  public filters?: ClaimFilterModel;

  public userId?: string;
  public userClaims?: any[];
  public currentTabIndex = 0;
  public tabIndex: any;

  readonly typeFilterInd = 'archived-ind-filters';
  readonly typeFilterColective = 'archived-colec-filters';
  readonly typeFilterMulti = 'archived-multi-filters';

  public filterKey = '';
  public haveResults: boolean = true;

  private AES = new AESEncryptDecryptService();

  constructor(
    private localStorageService: LocalStorageServiceBase,
    private getColectiveClaimsUsecase: GetFinishedColectiveUseCase,
    private getMultiSingleClaimsUsecase: GetFinishedMultiUseCase,
    private getPaginatedAllClaimsUseCase: GetFinishedSingleUseCase,
    private filterService: FilterServiceService
  ) {}

  async ngOnInit(): Promise<void> {
    this.userId = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_id')
    );
    await this.onTabChange({ index: 0 });
  }

  async onTabChange(event: any): Promise<void> {
    this.tabIndex = event.index;
    this.skeleton = true;
    this.currentTabIndex = this.tabIndex;

    const params = new ClaimsPaginationParamsModel(
      this.pagination.actualPage,
      this.pagination.itemsPerPage,
      undefined,
      undefined,
      undefined,
      this.userId
    );

    this.filterKey = this.getCurrentFilterKey();
    this.loadFiltersForTab(this.filterKey);
    params.filters = this.filters;

    let result;
    switch (this.tabIndex) {
      case 0:
        this.isPluri = false;
        result = await this.getPaginatedAllClaimsUseCase.execute(params);
        break;
      case 1:
        this.isPluri = false;
        result = await this.getColectiveClaimsUsecase.execute(params);
        break;
      case 2:
        this.isPluri = true;
        result = await this.getMultiSingleClaimsUsecase.execute(params);
        break;
      default:
        this.skeleton = false;
        return;
    }

    if (result instanceof Failure) {
      this.haveResults = false;
      this.skeleton = false;
      return;
    }

    if (result) {
      this.userClaims = result.response;
      this.pagination.totalQuantity = result.totalQuantity;
      this.haveResults = true;
      setTimeout(() => {
        this.skeleton = false;
      }, 500);
    }
  }

  onFiltersApplied(filters: ClaimFilterModel) {
    this.filters = filters;
    this.pagination.actualPage = 1;

    const key = this.getCurrentFilterKey();
    this.filterService.setFilters(filters, key);

    this.onTabChange({ index: this.tabIndex });
  }

  onFilterCancel(): void {
    this.pagination.actualPage = 1;
    this.filters = undefined;

    const key = this.getCurrentFilterKey();
    this.filterService.clear(key);

    this.onTabChange({ index: this.tabIndex });
  }

  private getCurrentFilterKey(): string {
    switch (this.tabIndex) {
      case 0:
        return this.typeFilterInd;
      case 1:
        return this.typeFilterColective;
      case 2:
        return this.typeFilterMulti;
      default:
        return '';
    }
  }

  private loadFiltersForTab(filterKey: string): void {
    const savedFilters = this.filterService.getFilters(filterKey);
    if (savedFilters) {
      this.filters = savedFilters;
    } else {
      this.filters = undefined;
    }
  }
}
